import TriviaList from "components/TriviaGames/TriviaList";
import React from "react";

export default () => {
  return (
    <div>
      <TriviaList />
    </div>
  );
};
